import {
	AfterContentInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ContentChildren,
	inject,
	Input,
	OnDestroy,
	QueryList
} from "@angular/core";
import { merge, Observable, Subscription } from "rxjs";
import { startWith } from "rxjs/operators";
import { BpTabItemComponent } from "@modules/shared/bp-tabs/bp-tab-item/bp-tab-item.component";

/**
 * This component is a wrapper around mat-tabs - it projects content into mat-tab-group and mat-tab
 * but uses a custom header (the mat-tab-header is hidden)
 */

@Component({
	selector: "bp-tabs",
	templateUrl: "./bp-tabs.component.html",
	styleUrls: ["./bp-tabs.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpTabsComponent implements AfterContentInit, OnDestroy {
	@ContentChildren(BpTabItemComponent) public tabs: QueryList<BpTabItemComponent>;
	@Input() withPills: boolean = true;

	private cdRef = inject(ChangeDetectorRef);
	/** Subscription to changes in the tab labels. */
	private tabLabelSubscription = Subscription.EMPTY;

	public tabItems$: Observable<BpTabItemComponent[]>;
	public selectedIndex: number = 0; // this is used to communicate between material and our custom header

	ngAfterContentInit(): void {
		this.subscribeToTabLabels();
		// this observable subscribes to changes in tabs children
		// - 'startWith' provides an initial value with which the first CD cycle is triggered after content is loaded
		this.tabItems$ = this.tabs.changes.pipe(startWith(this.tabs));
	}

	ngOnDestroy(): void {
		this.tabLabelSubscription.unsubscribe();
	}

	private subscribeToTabLabels(): void {
		if (this.tabLabelSubscription) {
			this.tabLabelSubscription.unsubscribe();
		}

		this.tabLabelSubscription = merge(...this.tabs.map((tab) => tab._stateChanges)).subscribe(() =>
			this.cdRef.markForCheck()
		);
	}
}
